import { StyleSheet } from 'react-native';

import { C } from 'common';
import { THEME, LAYOUT } from 'reactor/common';

const { LAYOUT: { HEADER } } = C;
const {
  BORDER_RADIUS, COLOR, ELEVATION, OFFSET, UNIT, SPACE,
} = THEME;
const PROFILE_SIZE = UNIT * 3.2;

export default StyleSheet.create({
  actions: {
    ...LAYOUT.STYLE.ROW,
    justifyContent: 'flex-end',
    flex: 1,
  },

  arrow: {
    borderLeftColor: COLOR.TRANSPARENT,
    borderLeftWidth: SPACE.MEDIUM,
    borderBottomColor: COLOR.WHITE,
    borderBottomWidth: SPACE.S,
    position: 'absolute',
    top: 0,
    right: 0,
    transform: [{ translateY: '-10px' }],
  },

  button: {
    marginLeft: UNIT,
  },

  container: {
    ...ELEVATION.SMALL,
    ...LAYOUT.STYLE.ROW,
    ...LAYOUT.STYLE.SHADOW,
    backgroundColor: COLOR.WHITE,
    height: HEADER.HEIGHT,
    paddingHorizontal: OFFSET,
    paddingRight: SPACE.XS,
    zIndex: 2,
  },

  containerLandscape: {
    justifyContent: 'flex-end',
    paddingRight: OFFSET,
  },

  contentPortrait: {
    ...LAYOUT.STYLE.ROW,
    justifyContent: 'space-between',
    width: '100%',
  },

  logo: {
    marginRight: OFFSET,
    height: UNIT * 3.2,
    width: UNIT * 9.6,
  },

  touchable: {
    ...LAYOUT.STYLE.ROW,
  },

  inputPicker: {
    marginBottom: 0,
    marginRight: OFFSET,
  },

  profile: {
    alignItems: 'center',
    backgroundColor: COLOR.BASE,
    borderRadius: PROFILE_SIZE / 2,
    height: PROFILE_SIZE,
    justifyContent: 'center',
    marginVertical: SPACE.S,
    width: PROFILE_SIZE,
  },

  tooltip: {
    ...ELEVATION.SMALL,
    position: 'absolute',
    top: UNIT * 6.4,
    right: SPACE.S,
    backgroundColor: 'white',
    padding: SPACE.REGULAR,
    borderBottomColor: COLOR.PRIMARY,
    borderBottomWidth: 4,
    minWidth: UNIT * 24,
    borderRadius: BORDER_RADIUS,
  },

  icon: {
    transform: [{ rotate: '90deg' }],
    marginHorizontal: SPACE.XXS,
  },
});
